import React from 'react';
import AssignModal from 'components/AssignModal';
import useFetch from 'components/shared/hooks/useFetch';
import { routes } from 'constants/config';
import { hasFeatureFlags } from 'utils/features';
import { getQueryParam } from 'utils/url';

const ReadyToAssign = ({ lesson }) => {
  const isArchived = lesson.archivedAt !== null;
  const isDraft = lesson.state === 'draft';
  const currentGroupId = getQueryParam(window.location.href, 'group_id');
  const { data, error, loading } = useFetch(
    routes.LESSON_OVERVIEW.ASSIGNMENT_SUMMARY(lesson.id, currentGroupId),
  );
  if (loading || error) return null;

  const { hasAssignments } = data;

  const state = {
    meta: {
      features: {
        scheduled_assignments: hasFeatureFlags('scheduled_assignments'),
        resource_experiment: hasFeatureFlags('resource_experiment'),
      },
      i18n: {
        smart_groups_calculation_tooltip: t(
          'assign_modal.smart_groups_calculation_tooltip',
        ),
        invalid_group_tooltip: lesson.permissions.isCurrentUserAdmin
          ? t('assign_modal.invalid_group_tooltip_admin')
          : t('smart_groups.blank_slates.invalid.description'),
        button_text: t('actions.assign'),
        assign_error_message: t('assign_modal.assign_error_message'),
      },
    },
  };

  return (
    <>
      {!hasAssignments && !isArchived && !isDraft && !lesson.isPublic && (
        <div className="d-f ff-ss fd-c mw-450 pt-16 pl-16 LessonOverviewLayout">
          <h3 className="ff-ss fw-b fz-24 lh-32 mb-8 mt-8">
            {t('lesson_overview.ready_to_assign_title')}
          </h3>
          <span className="fz-14 lh-20 mt-8 mb-8">
            {t('lesson_overview.ready_to_assign_body')}
          </span>
          <div className="mt-8 mb-8">
            <AssignModal state={state} />
          </div>
        </div>
      )}
    </>
  );
};

export default props => <ReadyToAssign {...props} />;
